export default __webpack_public_path__ + "static/br2-3b23ef04484a4f2265d51ceb2fd912e0.png";